import { Box, Paper, Stack } from '@mui/material';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  DashboardHeader,
  DashboardSearchBar,
  DashboardTabPanel,
  DashboardTabs,
} from './components';
import { ADMIN_PANEL_TABS, DEFAULT_ADMIN_PANEL_SLUG } from './constants';
import { DashboardOverview } from './Containers';
import { useAdminDashboard, useAdminDashboardTabs, } from './hooks';

export const AdminDashboard = () => {
  const { loading, timeData, orderedJobOpenings, mappedUserAssessments } = useAdminDashboard();
  const {
    path,
    url,
    tabs,
    activeSlug,
    activeTab,
    searchTerm,
    setSearchTerm,
    handleTabChange,
    handleClearSearch,
  } = useAdminDashboardTabs();

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        bgcolor: 'transparent',
      }}
    >
      <DashboardHeader
        title="Overview"
        subtitle="Real-time analytics and recruitment overview"
      />

      <DashboardOverview
        loading={loading}
        timeData={timeData}
        orderedJobOpenings={orderedJobOpenings}
        mappedUserAssessments={mappedUserAssessments}
      />

      <Stack spacing={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          alignItems={{ xs: 'stretch', sm: 'flex-end' }}
          justifyContent="space-between"
          sx={{ borderBottom: '1px solid #e4e4e7', pb: { xs: 1, sm: 0 } }}
        >
          <DashboardTabs
            tabs={tabs}
            activeSlug={activeSlug}
            baseUrl={url}
            onChange={handleTabChange}
          />
          <Box sx={{ pb: { sm: 0.75 } }}>
            <DashboardSearchBar
              value={searchTerm}
              placeholder={`Search ${activeTab}...`}
              onChange={setSearchTerm}
              onClear={handleClearSearch}
            />
          </Box>
        </Stack>

        <Box
          sx={{
            bgcolor: '#ffffff',
            border: '1px solid #e4e4e7',
            borderRadius: '6px',
            overflow: 'hidden',
          }}
        >
          <DashboardTabPanel
            id={`dashboard-tabpanel-${activeSlug}`}
            labelledBy={`dashboard-tab-${activeSlug}`}
          >
            <Switch>
              <Route exact path={path}>
                <Redirect to={`${url}/${DEFAULT_ADMIN_PANEL_SLUG}`} />
              </Route>
              {ADMIN_PANEL_TABS.map(({ slug, component: TabComponent }) => (
                <Route key={slug} path={`${path}/${slug}`}>
                  <TabComponent searchTerm={searchTerm} />
                </Route>
              ))}
              <Route path={`${path}/:tabSlug`}>
                <Redirect to={`${url}/${DEFAULT_ADMIN_PANEL_SLUG}`} />
              </Route>
            </Switch>
          </DashboardTabPanel>
        </Box>
      </Stack>
    </Box>
  );
};
